import { render, staticRenderFns } from "./wrongdetail.vue?vue&type=template&id=5514fa9b&scoped=true&"
import script from "./wrongdetail.vue?vue&type=script&lang=js&"
export * from "./wrongdetail.vue?vue&type=script&lang=js&"
import style0 from "./wrongdetail.vue?vue&type=style&index=0&id=5514fa9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5514fa9b",
  null
  
)

export default component.exports